export default (error: unknown) => {
    let errorMessage = error;
    if (typeof error === 'string') {
        errorMessage = error.toUpperCase();
    } else if (error instanceof Error) {
        errorMessage = error.message;
    }
    return errorMessage;
};
